import Components from './ui/components/_index';
import helpers from 'helpers';
import Vue from 'vue';



const APP_ID = 'dn-app';
const childComponents = [
  {name: 'dn-attribute-dialog', options: {ref: 'attributeDialog'}},
  {name: 'dn-alert-dialog', options: {ref: 'alertDialog'}},
  {name: 'dn-confirm-dialog', options: {ref: 'confirmDialog'}},
  {name: 'dn-db-manager', options: {ref: 'dbManager'}},
  {name: 'dn-loading', options: {ref: 'loading'}},
];

const getApp = (id = APP_ID) => {

  // linksetとoutputStatusを新機能に置き換える
  const $linkSets = $('.linkSet');
  $linkSets.each(function() {
    const $el = $(this);
    const id = $el.attr('data-url_id');
    $el.removeClass('linkSet');
    $el.removeAttr('data-url_id');
    $el.attr('v-linkset', `'${id}'`);
    $el.attr('data-lazy-mount', '');
  });

  const $outputStatuses = $('.outputStatus');
  $outputStatuses.each(function() {
    const $el = $(this);
    const id = $el.attr('data-id');
    $el.removeClass('outputStatus');
    $el.removeAttr('data-id');
    $el.attr('v-html', `$store.getters['status/displayAt']('${id}')`);
    $el.attr('data-lazy-mount', '');
  });

  // 「先輩からの入試直前アドバイス」用
  const $outputStatusesSenpai = $('.outputStatusSenpai');
  $outputStatusesSenpai.each(function() {
    const $el = $(this);
    const id = $el.attr('data-id');
    $el.removeClass('outputStatusSenpai');
    $el.removeAttr('data-id');
    $el.attr('v-html', `$store.getters['status/displayAtSenpai']('${id}')`);
    $el.attr('data-lazy-mount', '');
  });

  // 得点調整の文言表示非表示調整用
  const $outputStatusChosei = $('.outputStatusChosei');
  $outputStatusChosei.each(function() {
    const $el = $(this);
    const id = $el.attr('data-id');
    $el.removeClass('outputStatusChosei');
    $el.removeAttr('data-id');
    $el.attr(':style', `$store.getters['status/displayAtChosei']('${id}')`);
    $el.attr('data-lazy-mount', '');
  });

  const $app = document.getElementById(id) || (() => {
    const $app = document.createElement('div');
    $app.id = id;
    $app.setAttribute('data-dn-app', '');
    $app.setAttribute('v-cloak', '');
    document.body.appendChild($app);

    const $lazyMounts = Array.prototype.slice.call(document.querySelectorAll('[data-lazy-mount]'));
    for (let el of $lazyMounts) {
      const is = el.getAttribute('is');
      if (!is) {
        const vm = new Vue({parent: window.dn, template: el.outerHTML});
        vm.$mount(el);
        continue;
      }

      const name = helpers.snake2camel(is.replace(/^dn-/, ''), true);
      const options = Components[name];

      if (options) {
        const vm = new Vue(Object.assign({parent: window.dn, template: el.innerHTML}, options));
        vm.$mount(el);
      } else {
        console.error(`vue コンポーネント「${name}」は定義されていません`);
      }
    }

    return $app;
  })();

  for (let c of childComponents) {
    const el = document.createElement('div');
    el.setAttribute('is', c.name);
    el.setAttribute('ref', c.options.ref);
    $app.appendChild(el);
  }
  return $app;
}

export default function bootstrap() {
  const dn = window.dn;
  const $app = getApp();
  dn.$mount($app);
  // 大学検索は遅れてマウントさせる /center/bible/search/ から /bible/search/ に条件変更。dn2022などかこのアーカイブ化で問題になったため
  let currentUrl = location.href;
  if (currentUrl.includes('/bible/search')) {
    var script_cunk = document.createElement('script');
    script_cunk.src = '../../resources/bible/search/js/chunk-vendors.js';
    var script_app = document.createElement('script');
    script_app.src = '../../resources/bible/search/js/app.js';
    document.body.appendChild(script_cunk);
    document.body.appendChild(script_app);
  }
}



// WEBPACK FOOTER //
// ./src/js/bootstrap.js